import { Box, Typography } from '@mui/material';
import TokenUsageSlider from './TokenUsageSlider/TokenUsageSlider';
import useTokenUsage from './useTokenUsage';
import TokenUsageTable from './TokenUsageTable/TokenUsageTable';
import { saasModernTheme } from 'common/theme/saasModern';
import { useTranslations } from 'hooks/useTranslations';

const TokenUsage = ({ subPlansTokenUsage, botsUseCaseLabel, locale }) => {
  const { t } = useTranslations();
  const { tokenUsage, handleTokenUsageChange, columns, rows } = useTokenUsage({
    botsUseCaseLabel,
  });
  return (
    <Box
      display={'flex'}
      marginTop="80px"
      flexDirection={'column'}
      justifyContent={'center'}
      gap={1}
      width={'100%'}
    >
      <Typography
        fontWeight={'700'}
        variant="h3"
        textAlign={'center'}
        sx={{
          color: 'black',
        }}
      >
        {locale === 'fr-fr' ? (
          <>
            {t('pricing.token.title')}
            <Box
              sx={{
                display: 'inline',
                background:
                  'linear-gradient(90deg, #FF6E72 62.63%, #FFB656 99.89%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              {t('pricing.token.title2')}
            </Box>
          </>
        ) : (
          <>
            <Box
              sx={{
                display: 'inline',
                background:
                  'linear-gradient(90deg, #FF6E72 62.63%, #FFB656 99.89%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              {t('pricing.token.title')}
            </Box>
            {t('pricing.token.title2')}
          </>
        )}
      </Typography>

      <Typography
        variant="h4"
        sx={{
          color: '#888C93',
          fontFamily: saasModernTheme.fontFamily,
          fontSize: '20px',
          fontWeight: 400,
          textAlign: 'center',
          margin: 'auto',
          width: '80%',
          my: 2,
        }}
      >
        {t('pricing.token.description')}
      </Typography>
      <TokenUsageSlider
        subPlansTokenUsage={subPlansTokenUsage}
        value={tokenUsage}
        onChange={handleTokenUsageChange}
      />
      <TokenUsageTable columns={columns} rows={rows} />
    </Box>
  );
};
export default TokenUsage;
